import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, AlertCircle, Loader2 } from 'lucide-react';
import AdminLayout from '../components/AdminLayout';
import { getJobList } from '../services/adminApi';

function formatDate(value) {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return value;
  }
}

const AdminJobsPage = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await getJobList();
        if (cancelled) return;

        if (!res.ok || res.status === false) {
          setError(res.message || 'İlan listesi alınamadı.');
          setJobs([]);
          return;
        }

        setJobs(res.data || []);
      } catch {
        if (!cancelled) {
          setError('Sunucuya ulaşılamadı. Bağlantınızı kontrol edin.');
          setJobs([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AdminLayout title="İlanlar">
      <div className="admin-panel-card">
        {loading && (
          <div className="admin-placeholder">
            <Loader2 className="spin" />
            <h3>Yükleniyor...</h3>
          </div>
        )}

        {!loading && error && (
          <div className="admin-placeholder">
            <AlertCircle />
            <h3>İlan listesi alınamadı</h3>
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && jobs?.length === 0 && (
          <div className="admin-placeholder">
            <Briefcase />
            <h3>Henüz ilan yok</h3>
            <p>Aktif bir iş ilanı bulunmuyor.</p>
          </div>
        )}

        {!loading && !error && jobs?.length > 0 && (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Başlık</th>
                  <th>Şirket</th>
                  <th>Konum</th>
                  <th>Çalışma Şekli</th>
                  <th>Kaynak</th>
                  <th>Yayın Tarihi</th>
                  <th>Durum</th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((j) => (
                  <tr
                    key={j.id}
                    className="admin-table-row--clickable"
                    // URL okunabilirlik için slug taşır; GetJobDetail'in beklediği
                    // gerçek id (temp_job.id) navigate state'i ile ayrıca gönderilir.
                    onClick={() => navigate(`/panel/ilanlar/${encodeURIComponent(j.slug)}`, { state: { id: j.id } })}
                  >
                    <td>{j.title || '-'}</td>
                    <td>{j.company || '-'}</td>
                    <td>{j.location || '-'}</td>
                    <td>{j.jobType || '-'}</td>
                    <td>{j.source || '-'}</td>
                    <td>{formatDate(j.publishedAt)}</td>
                    <td>
                      <span
                        className="admin-badge"
                        style={
                          j.isActive
                            ? { color: '#0F9D58', background: '#E6F7EF' }
                            : { color: '#6B7280', background: '#F3F4F8' }
                        }
                      >
                        {j.isActive ? 'Aktif' : 'Pasif'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminJobsPage;
